/**
 * KAN-852: кнопки взятия в работу в приложении менеджера: "Взять в работу"
 * и "Назначить" (по роли и правам, решает useMobileWork; KAN-869: у обычного
 * менеджера на своём клиенте вторая кнопка "Передать"). Нечего показать
 * (чужой клиент у обычного менеджера): ничего.
 */
import { UserCheck, Users } from 'lucide-react';
import { TAKE_TO_WORK_LABEL } from '@/lib/workActions';
import { cn } from '@/lib/utils';
import type { MobileWork } from '@/hooks/useMobileWork';

const BTN = 'flex min-h-[48px] items-center justify-center gap-2 rounded-xl px-4 text-base font-medium disabled:opacity-50';

interface Props {
  work: Pick<MobileWork, 'canTake' | 'canAssign' | 'assignLabel' | 'take' | 'assign'>;
  disabled?: boolean;
  testIdPrefix?: string;
}

export function MobileWorkButtons({ work, disabled = false, testIdPrefix = 'mobile-work' }: Props): JSX.Element | null {
  if (!work.canTake && !work.canAssign) return null;
  const both = work.canTake && work.canAssign;
  return (
    <div className={cn('grid gap-2', both ? 'grid-cols-2' : 'grid-cols-1')} data-testid={`${testIdPrefix}-buttons`}>
      {work.canTake && (
        <button
          type="button"
          disabled={disabled}
          onClick={work.take}
          className={cn(BTN, 'bg-blue-600 text-white')}
          data-testid={`${testIdPrefix}-take`}
        >
          <UserCheck className="h-5 w-5" aria-hidden="true" />
          {TAKE_TO_WORK_LABEL}
        </button>
      )}
      {work.canAssign && (
        <button
          type="button"
          disabled={disabled}
          onClick={work.assign}
          className={cn(BTN, work.canTake ? 'border border-gray-300 bg-white text-gray-900' : 'bg-blue-600 text-white')}
          data-testid={`${testIdPrefix}-assign`}
        >
          <Users className="h-5 w-5" aria-hidden="true" />
          {work.assignLabel}
        </button>
      )}
    </div>
  );
}
